
import { Routes } from '@angular/router';
import { AuthGuard } from '@uoa/auth';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'error/:errorCode',
    loadChildren: () => import('./app/error-routing/error.routes').then((m) => m.errorRoutes),
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./app/pages/home/home.routes').then((m) => m.homeRoutes),
  },
  {
    path: 'manage-token',
    canActivate: [AuthGuard],
    loadChildren: () => import('./app/pages/manage-token/manage-token.routes').then( m => m.protectedRoutes)
  },
  {
    path: 'yubikey',
    canActivate: [AuthGuard],
    loadChildren: () => import('./app/pages/yubikey/yubikey.routes').then( m => m.protectedRoutes)
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./app/pages/admin/admin.routes').then( m => m.protectedRoutes)
  },
  {
    path: 'admin/audit',
    canActivate: [AuthGuard],
    loadChildren: () => import('./app/pages/audit/audit.routes').then( m => m.protectedRoutes)
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];